var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "account-nav" },
    [
      _c("h1", { staticClass: "account-nav__name" }, [
        _vm._v("Hello, " + _vm._s(_vm.customerName))
      ]),
      _c("p", { staticClass: "account-nav__email" }, [
        _vm._v(_vm._s(_vm.customerEmail))
      ]),
      ["mobile", "tablet"].includes(_vm.$mq)
        ? _c(
            "a",
            {
              staticClass: "account-nav__logout",
              attrs: { href: "/account/logout" }
            },
            [_vm._v("Logout")]
          )
        : _vm._e(),
      ["mobile", "tablet"].includes(_vm.$mq) && !_vm.hideNav
        ? _c("select-input", {
            staticClass: "account-nav__select",
            attrs: { selected: _vm.selected, options: _vm.options }
          })
        : !_vm.hideNav
        ? _c(
            "ul",
            { staticClass: "account-nav__list u-list-simple" },
            _vm._l(_vm.options, function(option) {
              return _c(
                "li",
                {
                  staticClass: "account-nav__list-item",
                  class: { "item-active": _vm.isActive(option.value) }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "account-nav__list-item-link",
                      attrs: { href: option.value }
                    },
                    [_vm._v(_vm._s(option.label))]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        "a",
        {
          staticClass: "account-nav__logout",
          attrs: { href: "/account/logout" }
        },
        [_vm._v("Logout")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }